import { render } from "./GeneratedAlertList.component.vue?vue&type=template&id=449087c2&scoped=true&ts=true"
import script from "./GeneratedAlertList.component.vue?vue&type=script&lang=ts"
export * from "./GeneratedAlertList.component.vue?vue&type=script&lang=ts"

import "./GeneratedAlertList.component.vue?vue&type=style&index=0&id=449087c2&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/WEAS/WEAS_CI/WEAS_FRONT/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-449087c2"]])

export default __exports__